export default function getDiscountOptions(
  currency,
  getCurrencySymbol = () => null
) {
  return [
    {
      value: 'amount',
      label: getCurrencySymbol() ?? currency?.symbol,
    },
    {
      value: 'percent',
      label: '%',
    },
  ];
}
